import { Navigate } from "react-router"
import { useCustomerType } from "../utils"
import { CustomerType } from "@nano-portal/customers"
import { assertUnreachable } from "../../../../../utils/types"
import { BusinessContractTypeForm } from "./BusinessContractTypeForm"
import { HouseholdContractTypeForm } from "./HouseholdContractTypeForm"
import { ACQUISITION_FORM_LINKS } from "../links"

function getContractTypeForm(customerType: CustomerType) {
  switch (customerType) {
    case "business":
      return BusinessContractTypeForm
    case "household":
      return HouseholdContractTypeForm
    default:
      return assertUnreachable(customerType)
  }
}

export function ContractTypePage() {
  const customerType = useCustomerType()
  if (!customerType) {
    return <Navigate to={`..${ACQUISITION_FORM_LINKS.CUSTOMER_TYPE}`} />
  }

  const CustomerTypeForm = getContractTypeForm(customerType)
  return <CustomerTypeForm />
}
